<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 11.6666L17.5 7.49992L10 3.33325L2.5 7.49992L10 11.6666ZM10 11.6666L15.1326 8.81513C15.5848 9.95541 15.8333 11.1986 15.8333 12.4999C15.8333 13.0843 15.7832 13.657 15.687 14.214C13.5119 14.4255 11.5409 15.3338 10 16.7129C8.45914 15.3338 6.48809 14.4255 4.31301 14.214C4.2168 13.657 4.16667 13.0843 4.16667 12.4998C4.16667 11.1986 4.4152 9.95539 4.8674 8.81512L10 11.6666ZM6.66667 16.6665V10.4166L10 8.56473"
      :stroke="color"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "#003D6A",
  },
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "20",
  },
});
</script>
